import { getLibraryIcon, libraryIcons } from "./icons.js";
import LibraryIcon_default from "./LibraryIcon.vue.js";
export { LibraryIcon_default as LibraryIcon, getLibraryIcon, libraryIcons };
